import React, { useEffect, useState } from "react";
import { getTopChargebacks } from "../../../../../api";
import MenuIcon40 from "../../../../assets/svg/icons/common/MenuIcon40";
import TrendDown24 from "../../../../assets/svg/icons/common/TrendDown24";
import TrendUp24 from "../../../../assets/svg/icons/common/TrendUp24";
import SkeletonLoader from "../../../../components/skeleton-loader";
import useDashboardStore from "../../../../stores/dashboard";
import MerchantNameLink from "../../../../components/MerchantNameLink";
import styles from "./style.module.scss";

const formatNumber = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + "B";
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
};

const Chargebacks = () => {
  const [chargebacks, setChargebacks] = useState([]);
  const [loading, setLoading] = useState(true);

  const filterStartDate = useDashboardStore(
    (state) => state.filterData.startDate,
  );
  const filterEndDate = useDashboardStore((state) => state.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterData.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterData.filterOrg);

  useEffect(() => {
    getTopChargebacks({
      start_date: filterStartDate,
      end_date: filterEndDate,
      user_id: filterUser,
      org_id: filterOrg,
    })
      .then((res) => {
        if (res.status) {
          setChargebacks(res.data);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [filterStartDate, filterEndDate, filterUser, filterOrg]);

  return (
    <div className={styles.activeMerchant}>
      <div className={styles.activeMerchantHeader}>
        <div className={styles.activeMerchantHeaderContent}>
          <p className={styles.activeMerchantHeaderTitle}>Chargebacks</p>
          <p className={styles.activeMerchantHeaderDate}>
            {new Date(filterStartDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}{" "}
            -{" "}
            {new Date(filterEndDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}
          </p>
        </div>
      </div>

      {loading && (
        <div className={styles.activeMerchantList}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.activeMerchantListItem}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  width: "100%",
                }}
              >
                <SkeletonLoader
                  variant="rectangular"
                  height={"20px"}
                  width={"100%"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
                <SkeletonLoader
                  variant="rectangular"
                  height={"16px"}
                  width={"60px"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {!loading && (
        <>
          {chargebacks?.length > 0 ? (
            <div className={styles.activeMerchantList}>
              {chargebacks.map((chargeback, index) => (
                <div key={index} className={styles.activeMerchantListItem}>
                  <div className={styles.activeMerchantListItemContent}>
                    <p className={styles.activeMerchantListItemTitle}>
                      <MerchantNameLink powerappId={chargeback.powerapp_id}>
                        {chargeback.dba_name}
                      </MerchantNameLink>
                    </p>
                    <p className={styles.activeMerchantListItemDescription}>
                      {index <= 1 && "Suspicious"}
                      {index == 2 && "Pay Attention"}
                      {index > 2 && "Normal"}
                    </p>
                  </div>

                  <div className={styles.amountContainer}>
                    <p
                      className={`${styles.amountValue} ${index <= 2 ? styles.colorWarning : ""}`}
                    >
                      $ {formatNumber(+chargeback.total_chargeback_amount)}
                    </p>
                  </div>

                  <div className={styles.trendContainer}>
                    <span className={styles.trendIcon}>
                      {chargeback.trend == "up" ? (
                        <TrendUp24 fill="#E03B24" />
                      ) : (
                        <TrendDown24 fill="#37B450" />
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.emptyContainer}>
              <div className={styles.iconBox}>
                <MenuIcon40 />
              </div>

              <p className={styles.emptyTitle}>
                This card will display chargeback volume by merchant,
                highlighting those with abnormal or suspicious activity
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Chargebacks;
